import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { ProgramTemplateStore, IProgramTemplateWithAccesLevel } from './program-template.store';

@Injectable({ providedIn: 'root' })
export class ProgramTemplateQuery extends Query<IProgramTemplateWithAccesLevel> {
  hasWriteAccess$() {
    return this.select().pipe(
      map((value) => value && value.access_level === 'WRITE'),
    );
  }

  constructor(protected store: ProgramTemplateStore) {
    super(store);
  }
}
